import { Flex, FormControl, FormErrorMessage } from "@chakra-ui/react";
import Input from "../inputs/Input";
import { FormProvider, useForm } from "react-hook-form";
import { forwardRef, useImperativeHandle } from "react";
import _ from "lodash";
import { Ticket, TicketPriority } from "../../types/ticket.types";
import Select from "../inputs/Select";
import FileInput from "../FileInput";
import { useTicketLabels } from "../../hooks/ticket_labels.hooks";

type CreateTicketFormProps = {
	defaultValue?: Partial<Ticket>;
	editableDefault?: boolean;
};

export type CreateTicketFormHandler = {
	valid: () => Promise<boolean>;
	values: () => Ticket;
	isDirty: () => boolean;
};

const CreateTicketForm = forwardRef<
	CreateTicketFormHandler,
	CreateTicketFormProps
>(({ defaultValue, editableDefault }, ref) => {
	const methods = useForm();
	editableDefault = editableDefault ?? true;
	// useEffect(() => {
	//   if (defaultValue) {
	//     methods.reset({
	//       ticketLabelId: defaultValue.ticketLabelId,
	//       commandId: defaultValue.commandId,
	//       priority: defaultValue.priority,
	//       description: defaultValue.description,
	//     });
	//   }
	// }, [methods, defaultValue]);
	useImperativeHandle(ref, () => ({
		valid: () => {
			return methods.trigger();
		},
		values: () => {
			return methods.getValues() as Ticket;
		},
		isDirty: () => {
			return !_.isEqual(methods.getValues(), {
				ticketLabelId: "",
				commandId: "",
				priority: TicketPriority.LOW,
				description: "",
				files: [],
			});
		},
	}));
	const { data: labels } = useTicketLabels({});

	return (
		<Flex w="100%">
			<FormProvider {...methods}>
				<form style={{ marginTop: "32px", width: "100%" }}>
					<Flex direction="column" gap="24px">
						<FormControl isInvalid={!!methods.formState.errors.ticketLabelId}>
							<Select
								id="ticketLabelId"
								placeholder="Motif"
								{...methods.register("ticketLabelId", {
									required: "Vous devez sélectionner un motif.",
								})}
								isDisabled={
									editableDefault === false &&
									defaultValue?.ticketLabelId != null
								}
							>
								{labels?.map((label) => (
									<option key={label.id} value={label.id}>
										{label.label}
									</option>
								))}
							</Select>
							<FormErrorMessage>
								<>{methods.formState.errors?.ticketLabelId?.message}</>
							</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!methods.formState.errors.commandId}>
							<Input
								id={"commandId"}
								placeholder="Numéro de commande"
								isDisabled={
									editableDefault === false && defaultValue?.commandId != null
								}
								defaultValue={defaultValue?.commandId}
								{...methods.register("commandId")}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.commandId?.message}</>
							</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!methods.formState.errors.priority}>
							<Select
								id={"priority"}
								placeholder="Priorité"
								defaultValue={TicketPriority.LOW}
								isDisabled={
									editableDefault === false && defaultValue?.priority != null
								}
								{...methods.register("priority", {
									required: "Vous devez sélectionner une priorité.",
								})}
							>
								<option value={TicketPriority.LOW}>Normale</option>
								<option value={TicketPriority.MEDIUM}>Moyenne</option>
								<option value={TicketPriority.HIGH}>Haute</option>
							</Select>
							<FormErrorMessage>
								<>{methods.formState.errors?.priority?.message}</>
							</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!methods.formState.errors.description}>
							<Input
								id={"description"}
								placeholder="Description"
								isDisabled={
									editableDefault === false && defaultValue?.description != null
								}
								{...methods.register("description")}
							></Input>
							<FormErrorMessage>
								<>{methods.formState.errors?.description?.message}</>
							</FormErrorMessage>
						</FormControl>

						<FormControl isInvalid={!!methods.formState.errors.files}>
							<FileInput {...methods.register("files")}></FileInput>
							<FormErrorMessage>
								<>{methods.formState.errors?.files?.message}</>
							</FormErrorMessage>
						</FormControl>
					</Flex>
				</form>
			</FormProvider>
		</Flex>
	);
});

export default CreateTicketForm;
